import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import SignIn from "./views/auth/SignIn";
import Forbidden from "./views/auth/Forbidden";
import RoleManager from "views/admin/role";

const App = () => {
  return (
    <Routes>
      <Route path="auth/sign-in" element={<SignIn />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="admin/notifications/:id" element={<RoleManager />} />
      <Route path="/" element={<Navigate to="/admin" replace />} />
      <Route path="/forbidden" element={<Forbidden />} key="forbidden" />
      
      {/* Redirection vers la page de connexion pour toutes les routes non définies (404) */}
      <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
    </Routes>
  );
};

export default App;